import { render, staticRenderFns } from "./TokensList.vue?vue&type=template&id=1358230e&scoped=true&"
import script from "./TokensList.vue?vue&type=script&lang=js&"
export * from "./TokensList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358230e",
  null
  
)

export default component.exports